import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Profile from "./views/OrganizationProfile.vue";
import Projects from "./views/Projects.vue";
import ProjectDetails from "./views/ProjectDetails.vue";
import DonatorDetails from "./views/DonatorDetails.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/components",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/donator-details",
      name: "donator-details",
      components: {
        header: AppHeader,
        default: DonatorDetails,
        footer: AppFooter
      }
    },
    {
      path: "/organization-profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    {
      path: "/Projects",
      name: "all-projects",
      components: {
        header: AppHeader,
        default: Projects,
        footer: AppFooter
      }
    },
    {
      path: "/Project-details",
      name: "project-details",
      components: {
        header: AppHeader,
        default: ProjectDetails,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
